/*
 * Copyright (C) 2019 Toshiba Corporation
 * SPDX-License-Identifier: Apache-2.0
 */

import { DThemeImage } from "../../d-image";
import { DThemeWhiteImageBase } from "./d-theme-white-image-base";

export class DThemeWhiteImage<VALUE = unknown>
	extends DThemeWhiteImageBase<VALUE>
	implements DThemeImage<VALUE> {}
